import { ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import addProduct from 'rangeConfig/bror/behaviors/addProduct';

const wallSectionsProductListConfig: ProductListConfig = {
  cardsSubtitle: 'typeName, communicatedSizeText',
  mobileCardText: 'communicatedSizeText',
  sortOrder: [{ path: 'dimensions.depth' }],
  categories: [
    {
      id: 'wall-sections',
      products: [{ path: 'type', value: ProductType.BROR_WALL_SECTION_UNIT }]
    },
    {
      id: 'wall-sections-sprs-300',
      categoryTitle:
        'storageone.productListCategoryTitleCombinations communicatedDimensionsLocalized.depth communicatedDimensionsLocalized.unit storageone.deep',
      products: [
        { path: 'type', value: ProductType.BROR_WALL_SPR },
        { path: 'communicatedDimensions.depth', value: 300 }
      ]
    },
    {
      id: 'wall-sections-sprs-450',
      categoryTitle:
        'storageone.productListCategoryTitleCombinations communicatedDimensionsLocalized.depth communicatedDimensionsLocalized.unit storageone.deep',
      products: [
        { path: 'type', value: ProductType.BROR_WALL_SPR },
        { path: 'communicatedDimensions.depth', value: 450 }
      ]
    },
    {
      id: 'wall-units',
      products: [
        { path: 'type', value: ProductType.BROR_WALL_SECTION_UNIT },
        { path: 'type', value: ProductType.BROR_WALL_SPR }
      ]
    }
  ],
  behaviors: {
    productClicked: [addProduct],
    productDropped: [addProduct]
  },
  cluster: []
};

export default wallSectionsProductListConfig;
